import axios from 'axios';

const api = axios.create({
  baseURL: '/api', // 基础 URL，可以根据实际情况修改
});

export default {
  // 获取菜单数据 (示例)
  getMenu() {
    return api.get('/menu');
  },
  // 创建订单 (示例)
  createOrder(orderData) {
    return api.post('/orders', orderData);
  },
  // 其他 API 请求...
};